import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-lg border-2 border-white/30 bg-brand-pink font-display font-black uppercase leading-tight tracking-wide text-white text-center shadow-[0_5px_0_0_theme(colors.brand.pinkdark)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-brand-pinkhover active:translate-y-[3px] active:shadow-[0_2px_0_0_theme(colors.brand.pinkdark)]';
  const sizes: Record<string, string> = {
    md: 'px-4 py-3 text-sm',
    lg: 'px-4 py-3.5 text-base sm:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${sizes[size]} ${className}`} data-id="element-195" data-mp="137lcsrzgiish">
      {children}
    </a>;
}